import React, { type FC, useCallback, useMemo } from 'react';

import { SelectionPanelBase } from './SelectionPanelBase';
import { SelectionPanelItem } from './SelectionPanelItem';
import { LABWARE_TYPES } from '../../../constants';
import { createLabwareFromLabwareType } from '../../../features/actions';
import { closeSelectionPanel } from '../../../features/ui/uiSlice';
import { useAppDispatch } from '../../../hooks';
import type { LabwareType } from '../../../types';
import { labwareTypeToDisplayName } from '../../../utils';
import { Icon } from '../../customIcons/labware';

export const ConnectedLabwareSelectionPanel: FC<{}> = () => {
  const dispatch = useAppDispatch();

  const handleClickItem = useCallback(
    (labwareType: LabwareType) => {
      dispatch(createLabwareFromLabwareType({ labwareType }));
      // TODO(IL, 2024-03-18): have UI reducer do this itself
      dispatch(closeSelectionPanel());
    },
    [dispatch]
  );

  const labwareItems = useMemo(
    () =>
      LABWARE_TYPES.map((labwareType) => {
        return (
          <SelectionPanelItem
            key={labwareType}
            itemId={labwareType}
            icon={<Icon iconType={labwareType} fontSize="medium" />}
            label={labwareTypeToDisplayName(labwareType)}
            handleClickItem={handleClickItem}
          />
        );
      }),
    [handleClickItem]
  );

  return (
    <SelectionPanelBase title="Labware">{labwareItems}</SelectionPanelBase>
  );
};
